import { render } from "./Items.vue?vue&type=template&id=14ef5cf9&scoped=true"
import script from "./Items.vue?vue&type=script&lang=js"
export * from "./Items.vue?vue&type=script&lang=js"

import "./Items.vue?vue&type=style&index=0&id=14ef5cf9&scoped=true&lang=css"

import exportComponent from "/sv-shops-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ef5cf9"]])

export default __exports__